// ── Game over screen ──

import type { GameState, PlayerSlot } from '../game/state';
import { determineWinner } from '../game/scoring';

export function renderGameOver(
  container: HTMLElement,
  state: GameState,
  mySlot: PlayerSlot | null,
): void {
  const existing = container.querySelector('.game-over-overlay');
  if (existing) return;

  const winner = determineWinner(state.scores);
  const p1 = state.meta.player1;
  const p2 = state.meta.player2;

  let message: string;
  if (!winner) {
    message = 'Draw!';
  } else if (mySlot === null) {
    // Spectator
    const winnerName =
      winner === p1?.color ? p1?.name : p2?.name;
    message = `${winnerName ?? winner} wins!`;
  } else {
    const myColor = state.meta[mySlot]?.color;
    message = myColor === winner ? 'You win!' : 'You lose';
  }

  const overlay = document.createElement('div');
  overlay.className = 'game-over-overlay';
  overlay.innerHTML = `
    <div class="game-over-card">
      <h2 class="game-over-title">${message}</h2>
      <div class="game-over-scores">
        <div class="game-over-score">
          <span class="score-dot score-dot-black"></span>
          <span>${p1?.name ?? 'Black'}</span>
          <strong>${state.scores.black}</strong>
        </div>
        <div class="game-over-score">
          <span class="score-dot score-dot-red"></span>
          <span>${p2?.name ?? 'Red'}</span>
          <strong>${state.scores.red}</strong>
        </div>
      </div>
      <button class="btn btn-primary" id="btn-new-game">New Game</button>
    </div>
  `;

  container.appendChild(overlay);

  overlay.querySelector('#btn-new-game')!.addEventListener('click', () => {
    window.location.hash = '';
    window.location.reload();
  });
}
